(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aris-textile-commerce"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aris-textile-commerce')) {
    customElements.define('aris-textile-commerce', class extends HTMLElement {
      connectedCallback() {
        if (this.listener) return;
        this.listener = (event) => {
          if (!event.target.matches('[data-variant-select]')) return;
          this.updateVariant(event.target);
        };
        this.addEventListener('change', this.listener);
        this.querySelectorAll('[data-variant-select]').forEach((select) => this.updateVariant(select));
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.listener);
        this.listener = null;
      }

      updateVariant(select) {
        const card = select.closest('[data-textile-card]');
        const option = select.selectedOptions[0];
        const button = card.querySelector('[data-add-button]');
        const selected = Boolean(option && option.value && !option.disabled);
        if (button) button.disabled = !selected;
        if (!selected) return;
        const price = document.createElement('textarea');
        price.innerHTML = option.dataset.price;
        card.querySelector('[data-product-price]').textContent = price.value;
        card.querySelectorAll('[data-product-link]').forEach((link) => { link.href = option.dataset.url; });
        const image = card.querySelector('.aris-textile__image');
        if (image && option.dataset.image) {
          image.srcset = option.dataset.imageSrcset;
          image.src = option.dataset.image;
          image.alt = option.dataset.imageAlt;
          image.width = Number(option.dataset.imageWidth);
          image.height = Number(option.dataset.imageHeight);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-digital-storefront"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.lrd-storefront:not([data-lrd-ready])');
    roots.forEach((root) => {
      root.dataset.lrdReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('lrd-js');
      const items = root.querySelectorAll('.lrd-reveal');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-product-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lrdp').forEach((productSection) => {
  const variantSelect = productSection.querySelector('[data-lrdp-variant-select]');
  const price = productSection.querySelector('[data-lrdp-price]');
  const compare = productSection.querySelector('[data-lrdp-compare]');
  const mobilePrice = productSection.querySelector('[data-lrdp-mobile-price]');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const nextPrice = option ? option.dataset.price : '';
      const nextCompare = option ? option.dataset.compare : '';

      if (nextPrice && price) price.textContent = nextPrice;
      if (nextPrice && mobilePrice) mobilePrice.textContent = nextPrice;

      if (compare) {
        if (nextCompare) {
          compare.textContent = nextCompare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }
    });
  }
});

document.querySelectorAll('[data-lrdp-gallery]').forEach((gallery) => {
  const mediaWrap = gallery.closest('.lrdp__media-wrap');
  const mainImage = mediaWrap ? mediaWrap.querySelector('.lrdp__image') : null;
  const thumbs = gallery.querySelectorAll('[data-lrdp-thumb]');

  if (!mainImage || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');

      const nextSrc = thumb.dataset.src;
      const nextSrcset = thumb.dataset.srcset;
      const nextAlt = thumb.dataset.alt;

      if (nextSrc) mainImage.src = nextSrc;
      if (nextSrcset) mainImage.srcset = nextSrcset;
      if (nextAlt) mainImage.alt = nextAlt;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-smart-business-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.smbp').forEach((root) => {
  const variant = root.querySelector('[data-smbp-variant]');
  const price = root.querySelector('[data-smbp-price]');
  const compare = root.querySelector('[data-smbp-compare]');
  // Keep order-line metadata synchronized with the Shopify variant selected by the buyer.
  const productForm = root.querySelector('.smbp__form');
  const configIdField = productForm?.querySelector('[data-smbp-config-id]');
  const variantIdField = productForm?.querySelector('[data-smbp-property-variant-id]');
  const variantSkuField = productForm?.querySelector('[data-smbp-property-variant-sku]');
  const qrTypeField = productForm?.querySelector('[data-smbp-property-qr-type]');
  const personalizationFields = productForm?.querySelector('[data-smbp-personalization-fields]');
  const personalizationStage = productForm?.querySelector('[data-smbp-personalization-state]');
  const personalizationChoices = [...(productForm?.querySelectorAll('[data-smbp-mode-choice]') || [])];
  const checkoutNote = productForm?.querySelector('[data-smbp-checkout-note]');
  const syncPersonalization = () => {
    const prepareNow = personalizationChoices.some(choice => choice.checked && choice.dataset.smbpModeChoice === 'now');
    if (personalizationFields) {
      // Keep hidden required inputs and file uploads out of Shopify line items until the buyer opts in.
      personalizationFields.disabled = !prepareNow;
      personalizationFields.hidden = !prepareNow;
    }
    if (personalizationStage) personalizationStage.value = prepareNow ? 'prepared_pre_purchase' : 'pending_smart_hub';
    if (checkoutNote) checkoutNote.hidden = prepareNow;
  };
  personalizationChoices.forEach(choice => choice.addEventListener('change', syncPersonalization));
  syncPersonalization();
  if (configIdField && !configIdField.value) configIdField.value = crypto.randomUUID();
  const syncLineMetadata = () => {
    const selected = variant?.selectedOptions[0];
    const id = selected?.value || productForm?.querySelector('input[name="id"]')?.value || '';
    const sku = selected?.dataset.sku || variantSkuField?.value || '';
    if (variantIdField) variantIdField.value = id;
    if (variantSkuField) variantSkuField.value = sku;
    if (qrTypeField) qrTypeField.value = sku.includes('CONTACT') ? 'vcard' : sku.includes('WIFI') ? 'wifi' : sku.includes('REVIEW') || sku.includes('SOCIAL') || sku.includes('MENU') ? 'url' : 'custom';
  };
  syncLineMetadata();
  // The native product form and theme app scripts can disagree on quantity. Submit one
  // exact Shopify cart request from this form, preserving all personalization properties.
  const quantityControl = productForm?.querySelector('input[name="quantity"]');
  const submitButton = productForm?.querySelector('.smbp__submit');
  const cartStatus = productForm?.querySelector('[data-smbp-cart-status]');
  let cartSubmitting = false;
  let cartResultUncertain = false;
  const showCartStatus = (message) => {
    if (!cartStatus) return;
    cartStatus.textContent = message;
    cartStatus.hidden = !message;
  };
  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (cartSubmitting || cartResultUncertain) return;
    if (!productForm.reportValidity()) return;
    const quantity = Number(quantityControl?.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 50) {
      quantityControl?.setCustomValidity('Bitte wählen Sie eine Menge zwischen 1 und 50.');
      quantityControl?.reportValidity();
      return;
    }
    quantityControl?.setCustomValidity('');
    const variantId = variant?.value || productForm.querySelector('input[name="id"]')?.value;
    if (!variantId) { showCartStatus('Bitte wählen Sie zuerst eine Produktvariante.'); return; }
    const formData = new FormData(productForm);
    formData.set('id', String(variantId));
    formData.set('quantity', String(quantity));
    cartSubmitting = true;
    if (submitButton) submitButton.disabled = true;
    showCartStatus('Der Warenkorb wird aktualisiert …');
    try {
      const response = await fetch(root.dataset.smbpCartAddUrl, {
        method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:formData
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok) {
        showCartStatus(typeof payload?.description === 'string'
          ? payload.description
          : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte prüfen Sie Ihre Angaben.');
        return;
      }
      const confirmed = Number(payload?.quantity ?? payload?.items?.[0]?.quantity);
      // Shopify may return cumulative quantity if the same exact line already exists.
      if (!Number.isSafeInteger(confirmed) || confirmed < quantity) {
        cartResultUncertain = true;
        showCartStatus('Die gespeicherte Menge ist unklar. Bitte prüfen Sie den Warenkorb, bevor Sie erneut klicken.');
        return;
      }
      window.location.assign(root.dataset.smbpCartUrl);
    } catch (error) {
      // A network failure may happen after the server added the item: avoid double orders.
      cartResultUncertain = true;
      showCartStatus('Verbindung unterbrochen. Bitte überprüfen Sie zunächst den Warenkorb, bevor Sie erneut bestellen.');
    } finally {
      cartSubmitting = false;
      if (submitButton && !cartResultUncertain) submitButton.disabled = false;
    }
  });
  quantityControl?.addEventListener('input', () => { quantityControl.setCustomValidity(''); showCartStatus(''); });
  variant?.addEventListener('change', () => {
    if (configIdField) configIdField.value = crypto.randomUUID();
    syncLineMetadata();
    // Customer must re-approve the proof when choosing a different physical variant.
    const approval = productForm?.querySelector('input[name="properties[Designfreigabe bestätigt]"],input[name="properties[Entwurfsprüfung gewünscht]"]');
    if (approval) approval.checked = false;
  });

  if (variant) {
    variant.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      const nativeLink = root.querySelector('[data-native-editor-link]');
      const nativeUnavailable = root.querySelector('[data-native-editor-unavailable]');
      if (nativeLink) {
        const type = option?.dataset.nativeType;
        const enabled = !option?.disabled && ['vcard-plus', 'google-review'].includes(type);
        nativeLink.hidden = !enabled;
        if (nativeUnavailable) nativeUnavailable.hidden = enabled;
        if (enabled) {
          const destination = new URL('https://utralink.com/dashboard/qrcodes/new');
          destination.searchParams.set('type', type);
          destination.searchParams.set('shopify_variant', variant.value);
          nativeLink.href = destination.href;
        }
      }
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        if (option?.dataset.compare) {
          compare.textContent = option.dataset.compare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }
    });
  }

  const gallery = root.querySelector('[data-smbp-gallery]');
  const image = root.querySelector('.smbp__image');
  if (gallery && image) {
    gallery.querySelectorAll('[data-smbp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-smbp-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (thumb.dataset.src) image.src = thumb.dataset.src;
        if (thumb.dataset.srcset) image.srcset = thumb.dataset.srcset;
        if (thumb.dataset.alt) image.alt = thumb.dataset.alt;
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-smart-order-summary"]) return;
  try {
    
(() => {
  function lineTotal(cents, quantity, maximum) {
    const price = Number(cents);
    const count = Number(quantity);
    const limit = Number(maximum);
    const total = price * count;
    if (!Number.isSafeInteger(price) || price <= 0 || !Number.isSafeInteger(count) || count < 1 || count > limit || !Number.isSafeInteger(total)) return null;
    return total;
  }

  function initializeTotals() {
    document.querySelectorAll('[data-lrd-order-totals]').forEach((root) => {
      const records = new Map([...root.querySelectorAll('[data-total-record]')].map((record) => [record.dataset.id, record.dataset]));
      const form = [...document.querySelectorAll('.smbp__form')].find((candidate) => records.has(candidate.querySelector('[name="id"]')?.value));
      if (!form || root.lrdTotalsState?.form === form) return;
      root.lrdTotalsState?.dispose();
      const quantity = form.querySelector('[name="quantity"]');
      const variant = form.querySelector('[name="id"]');
      const button = form.querySelector('.smbp__submit');
      const template = root.querySelector('[data-summary-template]');
      if (!quantity || !variant || !button || !template) return;
      let formatter;
      try {
        formatter = new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency });
      } catch { return; }
      const controllers = new AbortController();
      const top = template.content.firstElementChild.cloneNode(true);
      const bottom = top.cloneNode(true);
      bottom.classList.add('lrd-order-total--checkout');
      quantity.insertAdjacentElement('afterend', top);
      button.before(bottom);
      const widgets = [top, bottom];
      const sync = () => {
        const selected = records.get(variant.value);
        const total = selected ? lineTotal(selected.cents, quantity.value, quantity.max || 50) : null;
        for (const widget of widgets) {
          widget.hidden = !selected;
          widget.querySelector('[data-total-variant]').textContent = selected?.title || '';
          widget.querySelector('[data-total-calculation]').textContent = total === null ? '' : `${Number(quantity.value)} \u00d7 ${selected.money} =`;
          widget.querySelector('[data-total-value]').textContent = total === null ? '\u2014' : formatter.format(total / 100);
        }
      };
      const options = { signal: controllers.signal };
      form.addEventListener('input', sync, options);
      form.addEventListener('change', sync, options);
      form.addEventListener('reset', () => queueMicrotask(sync), options);
      window.addEventListener('pageshow', sync, options);
      root.lrdTotalsState = {
        form,
        dispose() { controllers.abort(); widgets.forEach((widget) => widget.remove()); delete root.lrdTotalsState; }
      };
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTotals, { once: true });
  else initializeTotals();
  document.addEventListener('shopify:section:load', initializeTotals);
  document.addEventListener('shopify:section:unload', (event) => {
    document.querySelectorAll('[data-lrd-order-totals]').forEach((root) => {
      const state = root.lrdTotalsState;
      if (state && (event.target.contains(root) || event.target.contains(state.form))) state.dispose();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-solution-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lrdf]').forEach((finder) => {
  const choices = finder.querySelectorAll('[data-lrdf-choice]');
  const title = finder.querySelector('[data-lrdf-title]');
  const text = finder.querySelector('[data-lrdf-text]');
  const link = finder.querySelector('[data-lrdf-link]');
  const linkLabel = finder.querySelector('[data-lrdf-link-label]');

  choices.forEach((choice) => {
    choice.addEventListener('click', () => {
      choices.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      choice.classList.add('is-active');
      choice.setAttribute('aria-pressed', 'true');

      if (title) title.textContent = choice.dataset.title || '';
      if (text) text.textContent = choice.dataset.text || '';
      if (link) link.setAttribute('href', choice.dataset.url || '#');
      if (linkLabel) linkLabel.textContent = choice.dataset.label || '';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-textile-commerce"]) return;
  try {
    
(() => {
  function initializeTextileCommerce(scope = document) {
    const roots = [...(scope.matches?.('[data-textile-commerce]') ? [scope] : []), ...scope.querySelectorAll('[data-textile-commerce]')];
    for (const root of roots) {
      if (root.dataset.textileBound) continue;
      root.dataset.textileBound = 'true';
      const page = document.querySelector('.lrd-tx-landing') || document.querySelector('#atta-textile-live-v6');
      const original = page?.querySelector(':scope .tx-products') || page?.querySelector(':scope .at-prods');
      if (!window.Shopify?.designMode && original && !original.closest('[data-textile-commerce]') && !root.contains(original)) {
        original.before(root);
        if (original.id === 'at-products') {
          original.id = 'at-design-archive';
          root.id = 'at-products';
        }
        const concepts = document.createElement('details');
        concepts.className = 'lrdtxc__concepts';
        concepts.open = Number(root.querySelector('[data-textile-count]')?.dataset.textileCount || 0) === 0;
        const label = document.createElement('summary');
        label.textContent = root.dataset.conceptsLabel;
        concepts.append(label, original);
        root.append(concepts);
      }
      let formatter;
      try { formatter = new Intl.NumberFormat(root.dataset.locale || 'de', {style:'currency',currency:root.dataset.currency}); } catch { formatter = null; }
      for (const form of root.querySelectorAll('.lrdtxc__form')) {
        const variant = form.querySelector('[data-textile-variant]');
        const quantity = form.querySelector('[data-textile-quantity]');
        const button = form.querySelector('[data-textile-add]');
        const subtotal = form.querySelector('[data-textile-subtotal]');
        const price = form.closest('[data-textile-card]')?.querySelector('[data-textile-price]');
        if (!variant || !quantity || !button || !subtotal) continue;
        const sync = (changedVariant = false) => {
          const choice = variant.selectedOptions[0];
          const cents = Number(choice?.dataset.cents);
          const minimum = Number(choice?.dataset.min || 1);
          const step = Number(choice?.dataset.step || 1);
          quantity.min = String(minimum); quantity.step = String(step);
          if (choice?.dataset.max) quantity.max = choice.dataset.max;
          else quantity.removeAttribute('max');
          if (changedVariant && !quantity.checkValidity()) quantity.value = String(minimum);
          const units = Number(quantity.value);
          const valid = Number.isSafeInteger(cents) && cents > 0 && Number.isSafeInteger(units) && units >= minimum && quantity.checkValidity() && Number.isSafeInteger(cents * units);
          button.disabled = !valid;
          if (price && choice) price.textContent = choice.dataset.money;
          subtotal.textContent = valid && formatter ? formatter.format(cents * units / 100) : '\u2014';
        };
        variant.addEventListener('change', () => sync(true));
        quantity.addEventListener('input', () => sync());
        quantity.addEventListener('change', () => sync());
        form.addEventListener('reset', () => queueMicrotask(() => sync()));
        form.addEventListener('submit', (event) => { sync(); if (button.disabled) {event.preventDefault(); form.reportValidity();} });
        window.addEventListener('pageshow', () => sync());
        sync();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeTextileCommerce(), {once:true});
  else initializeTextileCommerce();
  document.addEventListener('shopify:section:load', (event) => initializeTextileCommerce(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
